import Util from "../Util";

const KNOWN_LOCALE_PREFIXES = ["en", "zh-CN", "pt", "ar", "vi"];

/** Google / sitemap 以 en 为默认语言，Next 的 default locale 为 default */
export function normalizeSeoLocale(locale) {
  if (!locale || locale === "default") return "en";
  return locale;
}

export function normalizePagePath(pagePath) {
  if (pagePath == null || pagePath === "" || pagePath === "/") return "/";
  const path = String(pagePath).split("?")[0].split("#")[0];
  return path.startsWith("/") ? path : `/${path}`;
}

/** 始终输出 https://www.spikex.com/{locale}{path}（本地开发除外） */
export function buildCanonicalHref({ lang, pagePath, domain = "www" }) {
  const origin = Util.getOrigin(domain, { seo: true });
  const locale = normalizeSeoLocale(lang);
  const path = normalizePagePath(pagePath);
  const suffix = path === "/" ? "" : path;
  return `${origin}/${locale}${suffix}`;
}

/** 从 Next router 推导不含语言前缀的路径，如 /aicopy */
export function resolvePagePathFromRouter(router) {
  if (!router) return "/";
  const asPath = (router.asPath || "/").split("?")[0].split("#")[0] || "/";
  const locale = router.locale;

  if (locale && locale !== "default") {
    const prefix = `/${locale}`;
    if (asPath === prefix || asPath === `${prefix}/`) return "/";
    if (asPath.startsWith(`${prefix}/`)) {
      return asPath.slice(prefix.length) || "/";
    }
  }

  for (const code of KNOWN_LOCALE_PREFIXES) {
    const prefix = `/${code}`;
    if (asPath === prefix || asPath === `${prefix}/`) return "/";
    if (asPath.startsWith(`${prefix}/`)) {
      return asPath.slice(prefix.length) || "/";
    }
  }

  return asPath || "/";
}

export function resolveSeoPagePath(pageProps, router) {
  const fromProps = pageProps?.resolvedUrl ?? pageProps?.pageUrl;
  if (fromProps != null && fromProps !== "") {
    return normalizePagePath(fromProps);
  }
  // asPath 在 SSR 即可用；勿用 pathname（动态路由会为 /foo/[id]）
  if (router?.asPath) {
    return normalizePagePath(resolvePagePathFromRouter(router));
  }
  return "/";
}
